<template>
  <Header :menu="menu" v-if="header && header == 'userHeader'"/>
  <div class="drawer lg:drawer-open bg-base-200 dark:bg-neutral text-base-content dark:text-neutral-content min-h-screen">
    <input id="my-drawer-2" type="checkbox" class="drawer-toggle"> 
    <div class="drawer-content flex flex-col">
      <div class="flex flex-col w-full sm:p-4">
          <router-view></router-view>  
      </div>
    </div> 

    <div class="drawer-side z-30">
      <label for="my-drawer-2" aria-label="close sidebar" class="drawer-overlay"></label> 
      
      <div class="bg-base-200 dark:bg-neutral-800 min-h-full" :class="{'w-64 md:w-80': menu}">
        <Menu v-if="menu && menu == 'userMenu'"/>
        <QuestMenu v-if="menu && menu == 'questMenu'"/>
      </div>

    </div>
  </div>
  <Footer v-if="footer && footer == 'globalFooter'"/>
  <CookieConsent />
</template>

<script setup>
import Header from "./components/header/Header.vue";
import Footer from "./components/footer/Footer.vue";
import Menu from "./components/menu/Menu.vue";
import QuestMenu from "./components/menu/QuestMenu.vue";
import CookieConsent from "./components/CookieConsent.vue";
import { useSeo } from './compositions/useSeo'

import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import direction from "./utils/direction"
const route = useRoute();
const menu  = ref(false);
const header  = ref(false);
const footer  = ref(false);

useSeo();
watch(route, (route) => {
  const dir = direction.filter(i => i.page == route.name)[0]

    // Sayfayı en üste kaydır
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);

  if(dir){
    menu.value = typeof dir.menu === "undefined" ? direction[0].menu : dir.menu; 
    header.value = typeof dir.header === "undefined" ? direction[0].header : dir.header; 
    footer.value = typeof dir.footer === "undefined" ? direction[0].footer : dir.footer;          
  }else{
    menu.value = direction[0].menu;
    header.value = direction[0].header;
    footer.value = direction[0].footer;
  }
});
</script>